import { createWidgetMixin } from 'vue-instantsearch';
import { connectHits } from 'instantsearch.js/es/connectors';
import { fbFunctions } from "@/config/firebase";

import {
    AisInstantSearch,
    AisRefinementList,
    AisHits,
    AisHighlight,
    AisSearchBox,
    AisStats,
    AisPagination,
    AisConfigure,
} from 'vue-instantsearch';
import {i18n} from "@/i18n";

export default {
    mixins: [
        createWidgetMixin({ connector: connectHits })
    ],
    components: {
        AisInstantSearch,
        AisRefinementList,
        AisHits,
        AisHighlight,
        AisSearchBox,
        AisStats,
        AisPagination,
        AisConfigure
    },
    methods: {

    }
};


// WEBPACK FOOTER //
// ./src/pages/global/components/top-bar/components/users-custom-hit/users-custom-hit.js